import React, { Component } from "react";
import { App, leadType } from "../../../../app";
import InputForm from "../../html/inputForm";
import commonContext, { AppContext } from "../../../context/common";

interface IProps {}
interface IState {
    RTOChargeSwitch: boolean;
    HDFCERGOSwitch: boolean;
    DealerInsuranceSwitch: boolean;
}
export class VehicleAddMoreLoanAmount extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    base: String;
    constructor(props: IProps) {
        super(props);
        this.state = {
            RTOChargeSwitch: true,
            HDFCERGOSwitch: true,
            DealerInsuranceSwitch: false,
        };
    }
    componentDidMount() {
        this.setLead = (this.context as AppContext).setLead;
        this.base = (this.context as AppContext).base;
    }
    handleOnChange = (e: any) => {
        let state = {};
        state[e.target.name] = e.target.value;
        this.setLead(state);
    };
    handleOnRtoChange = async (e: any) => {
        this.lead = (this.context as AppContext).lead as leadType;
        let { value, min, max } = e.target;
        setTimeout(function () {
            value = Math.max(Number(min), Math.min(Number(max), Number(value)));
            this.setLead({ rtoEditAmount: value });
        }, 2000);
    };
    render() {
        this.lead = (this.context as AppContext).lead as leadType;
        return (
            <>
                {this.base == "zd-10-seconds" ? (
                    <>
                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            <div className="switch-wrap w-full flex flex-wrap justify-between sm:justify-start mb-4">
                                <p className="text-black openSans-SemiBold text-sm sm:text-base md:text-xl mr-3 md:mr-4 mr-5">
                                    RTO charges funded by the bank
                                </p>
                                <label className="switch mt-1">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => {
                                            if (
                                                this.lead
                                                    .roadTaxInsuranceAvailed
                                            ) {
                                                this.setLead({
                                                    rtoEditAmount: 0,
                                                    roadTaxInsuranceAvailed: false,
                                                });
                                            } else {
                                                this.setLead({
                                                    rtoEditAmount: this.lead
                                                        .rto,
                                                    roadTaxInsuranceAvailed: true,
                                                });
                                            }
                                        }}
                                        checked={
                                            this.lead.roadTaxInsuranceAvailed
                                        }
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            {this.lead.roadTaxInsuranceAvailed ? (
                                <div className="relative w-full">
                                    <InputForm
                                        label="Amount"
                                        prefix="Rs."
                                        errorText="Please enter Amount"
                                        name="rtoEditAmount"
                                        handlerOnChange={(e) => {
                                            this.handleOnChange(e);
                                            this.handleOnRtoChange(e);
                                        }}
                                        value={
                                            this.lead.rtoEditAmount
                                                ? this.lead.rtoEditAmount
                                                : this.lead.rto
                                        }
                                        min={(this.lead.rto / 100) * 85}
                                        max={this.lead.rto}
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    </>
                ) : (
                    ""
                )}

                <div className="relative w-full sm:w-1/2 mb-3 pl-0 sm:pl-2 md:pl-4">
                    <div className="switch-wrap w-full flex flex-wrap justify-between sm:justify-start mb-4">
                        <p className="text-black openSans-SemiBold text-sm sm:text-base md:text-xl mr-3 md:mr-4 mr-5">
                            HDFC ERGO Motor insurance
                        </p>
                        <label className="switch mt-1">
                            <input
                                type="checkbox"
                                onChange={(e) => {
                                    if (this.lead.motorInsuranceAvailed) {
                                        this.setLead({
                                            motorInsurancePremium: 0,
                                            dealerInsuranceAmtEdit: this.lead
                                                .dealerInsuranceAmt,
                                            motorInsuranceAvailed: false,
                                            dealerInsuranceAvailed:
                                                this.base == "dd-al"
                                                    ? false
                                                    : true,
                                        });
                                    } else {
                                        this.setLead({
                                            dealerInsuranceAmtEdit: 0,
                                            motorInsurancePremium: this.lead
                                                .motorInsurancePremAmt,

                                            motorInsuranceAvailed: true,
                                            dealerInsuranceAvailed: false,
                                        });
                                    }
                                }}
                                checked={this.lead.motorInsuranceAvailed}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>
                    {this.lead.motorInsuranceAvailed ? (
                        <div className="relative w-full">
                            <InputForm
                                label="Tentative insurance premium"
                                errorText="Please enter amount"
                                prefix="Rs."
                                infoText="This will be deducted from your loan amount"
                                name="motorInsurancePremium"
                                handlerOnChange={(e) => this.handleOnChange(e)}
                                value={
                                    this.lead.motorInsurancePremium
                                        ? this.lead.motorInsurancePremium
                                        : this.lead.motorInsurancePremAmt
                                }
                                readonly={true}
                            />
                        </div>
                    ) : (
                        ""
                    )}
                </div>
                {this.base == "zd-10-seconds" ? (
                    <>
                        <div className="relative w-full sm:w-1/2 mb-3 pr-0 sm:pr-2 md:pr-4">
                            <div className="switch-wrap w-full flex flex-wrap justify-between sm:justify-start mb-4">
                                <p className="text-black openSans-SemiBold text-sm sm:text-base md:text-xl mr-3 md:mr-4 mr-5">
                                    Dealer Insurance
                                </p>
                                <label className="switch mt-1">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => {
                                            if (
                                                this.lead.dealerInsuranceAvailed
                                            ) {
                                                this.setLead({
                                                    dealerInsuranceAmtEdit: 0,
                                                    dealerInsuranceAvailed: false,
                                                });
                                            } else {
                                                this.setLead({
                                                    motorInsurancePremium: 0,
                                                    dealerInsuranceAmtEdit: this
                                                        .lead
                                                        .dealerInsuranceAmt,
                                                    dealerInsuranceAvailed: true,
                                                });
                                            }
                                        }}
                                        checked={
                                            this.lead.dealerInsuranceAvailed
                                        }
                                    />
                                    <span className="slider round"></span>
                                </label>
                            </div>
                            {!this.lead.motorInsuranceAvailed &&
                            this.lead.dealerInsuranceAvailed ? (
                                <div className="relative w-full">
                                    <InputForm
                                        label="Tentative insurance premium"
                                        errorText="Please enter amount"
                                        prefix="Rs."
                                        infoText="This will be deducted from your loan amount"
                                        name="dealerInsuranceAmtEdit"
                                        handlerOnChange={(e) =>
                                            this.handleOnChange(e)
                                        }
                                        value={
                                            this.lead.dealerInsuranceAmtEdit
                                                ? this.lead
                                                      .dealerInsuranceAmtEdit
                                                : this.lead.dealerInsuranceAmt
                                        }
                                    />
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                    </>
                ) : (
                    ""
                )}
            </>
        );
    }
}

export default VehicleAddMoreLoanAmount;
